import { getAPIHost } from '@rsos/base-utils/metaTags';
import { createApiInstance } from '../utils/createApiInstance';

const baseURL = `${getAPIHost()}/v1/scorpius`;

const instance = createApiInstance(baseURL);

export default instance;
